import { render, staticRenderFns } from "./tipspointsale-form.vue?vue&type=template&id=2c2b045a"
import script from "./tipspointsale-form.vue?vue&type=script&lang=js"
export * from "./tipspointsale-form.vue?vue&type=script&lang=js"
import style0 from "./tipspointsale-form.vue?vue&type=style&index=0&id=2c2b045a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports